import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
  withCredentials: true
});

export const deliveryAPI = {
  getAll: (params) => API.get('/deliveries', { params }),
  getById: (id) => API.get(`/deliveries/${id}`),
  create: (data) => API.post('/deliveries', data),
  update: (id, data) => API.put(`/deliveries/${id}`, data),
  delete: (id) => API.delete(`/deliveries/${id}`),
  getDrivers: () => API.get('/deliveries/meta/drivers'),
  getPlates: () => API.get('/deliveries/meta/plates'),
};

export const customerAPI = {
  getAll: (params) => API.get('/customers', { params }),
  getById: (id) => API.get(`/customers/${id}`),
  create: (data) => API.post('/customers', data),
  update: (id, data) => API.put(`/customers/${id}`, data),
  delete: (id) => API.delete(`/customers/${id}`),
  getSummary: (id) => API.get(`/customers/${id}/summary`),
};

export const pullOutAPI = {
  getAll: (params) => API.get('/pull-outs', { params }),
  create: (data) => API.post('/pull-outs', data),
  update: (id, data) => API.put(`/pull-outs/${id}`, data),
  delete: (id) => API.delete(`/pull-outs/${id}`),
};

export const dashboardAPI = {
  getStats: () => API.get('/dashboard/stats'),
  getDailySummary: (days) => API.get('/dashboard/daily-summary', { params: { days } }),
  getTopDrivers: (days) => API.get('/dashboard/top-drivers', { params: { days } }),
  getTopCustomers: (days) => API.get('/dashboard/top-customers', { params: { days } }),
};

export default API;
